import React, { useState } from "react";

import ModalPreview from "./ModalPreview";

const MyGallery = () => {
  const [show, setShow] = useState(false);
  const [img, setImg] = useState({ img: null, title: "" });

  const handlePreview = (img) => {
    setImg(img);
    setShow(true);
  };

  return (
    <>
      <ModalPreview
        show={show}
        handleClose={() => setShow(false)}
        image={img}
      />

      <section id="gallery">
        <div className="container gallery">
          <div className="card">
            <div className="card-body best-seller-container">
              <h2 className="mb-3">Galeri Foto</h2>
              <p className="lead text-center">
                Berani berkreasi, Berani berekspresi
              </p>

              <div className="grid grid-view mt-5">
                <div className="row justify-content-evenly gy-6 ">
                  <div className="item col-md-6 col-xl-4 gallery-item">
                    <figure
                      className="overlay rounded"
                      onClick={() =>
                        handlePreview({
                          img: "https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-12.webp",
                          title: "B&W Filter",
                        })
                      }
                    >
                      <img
                        src="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-12.webp"
                        srcSet="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-12.webp"
                        alt="B&W Filter"
                      />
                      <figcaption>
                        <h4 className="from-top h6 mb-0">B&W Filter</h4>
                      </figcaption>
                    </figure>
                  </div>

                  <div className="item col-md-6 col-xl-4 gallery-item">
                    <figure
                      className="overlay rounded"
                      onClick={() =>
                        handlePreview({
                          img: "https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-20.webp",
                          title: "B&W Filter",
                        })
                      }
                    >
                      <img
                        src="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-20.webp"
                        srcSet="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-20.webp"
                        alt="B&W Filter"
                      />
                      <figcaption>
                        <h4 className="from-top h6 mb-0">B&W Filter</h4>
                      </figcaption>
                    </figure>
                  </div>
                  <div className="item col-md-6 col-xl-4 gallery-item">
                    <figure
                      className="overlay rounded"
                      onClick={() =>
                        handlePreview({
                          img: "https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-23.webp",
                          title: "B&W Filter",
                        })
                      }
                    >
                      <img
                        src="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-23.webp"
                        srcSet="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-23.webp"
                        alt="B&W Filter"
                      />

                      <figcaption>
                        <h4 className="from-top h6 mb-0">B&W Filter</h4>
                      </figcaption>
                    </figure>
                  </div>
                  <div className="item col-md-6 col-xl-4 gallery-item">
                    <figure
                      className="overlay rounded"
                      onClick={() =>
                        handlePreview({
                          img: "https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-24.webp",
                          title: "B&W Filter",
                        })
                      }
                    >
                      <img
                        src="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-24.webp"
                        srcSet="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-24.webp"
                        alt="B&W Filter"
                      />
                      <figcaption>
                        <h4 className="from-top h6 mb-0">B&W Filter</h4>
                      </figcaption>
                    </figure>
                  </div>
                  <div className="item col-md-6 col-xl-4 gallery-item">
                    <figure
                      className="overlay rounded"
                      onClick={() =>
                        handlePreview({
                          img: "https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-26.webp",
                          title: "B&W Filter",
                        })
                      }
                    >
                      <img
                        src="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-26.webp"
                        srcSet="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-26.webp"
                        alt="B&W Filter"
                      />
                      <figcaption>
                        <h4 className="from-top h6 mb-0">B&W Filter</h4>
                      </figcaption>
                    </figure>
                  </div>
                  <div className="item col-md-6 col-xl-4 gallery-item">
                    <figure
                      className="overlay rounded"
                      onClick={() =>
                        handlePreview({
                          img: "https://main.mobile.doss.co.id/storage/uploads/2022/08/blue-03.webp",
                          title: "Blue Filter",
                        })
                      }
                    >
                      <img
                        src="https://main.mobile.doss.co.id/storage/uploads/2022/08/blue-03.webp"
                        srcSet="https://main.mobile.doss.co.id/storage/uploads/2022/08/blue-03.webp"
                        alt="Blue Filter"
                      />
                      <figcaption>
                        <h4 className="from-top h6 mb-0">Blue Filter</h4>
                      </figcaption>
                    </figure>
                  </div>
                  <div className="item col-md-6 col-xl-4 gallery-item">
                    <figure
                      className="overlay rounded"
                      onClick={() =>
                        handlePreview({
                          img: "https://main.mobile.doss.co.id/storage/uploads/2022/08/blue-05.webp",
                          title: "Blue Filter",
                        })
                      }
                    >
                      <img
                        src="https://main.mobile.doss.co.id/storage/uploads/2022/08/blue-05.webp"
                        srcSet="https://main.mobile.doss.co.id/storage/uploads/2022/08/blue-05.webp"
                        alt="Blue Filter"
                      />
                      <figcaption>
                        <h4 className="from-top h6 mb-0">Blue Filter</h4>
                      </figcaption>
                    </figure>
                  </div>
                  <div className="item col-md-6 col-xl-4 gallery-item">
                    <figure
                      className="overlay rounded"
                      onClick={() =>
                        handlePreview({
                          img: "https://main.mobile.doss.co.id/storage/uploads/2022/08/blue-06.webp",
                          title: "Blue Filter",
                        })
                      }
                    >
                      <img
                        src="https://main.mobile.doss.co.id/storage/uploads/2022/08/blue-06.webp"
                        srcSet="https://main.mobile.doss.co.id/storage/uploads/2022/08/blue-06.webp"
                        alt="Blue Filter"
                      />
                      <figcaption>
                        <h4 className="from-top h6 mb-0">Blue Filter</h4>
                      </figcaption>
                    </figure>
                  </div>
                  <div className="item col-md-6 col-xl-4 gallery-item">
                    <figure
                      className="overlay rounded"
                      onClick={() =>
                        handlePreview({
                          img: "https://main.mobile.doss.co.id/storage/uploads/2022/08/sepia-03.webp",
                          title: "Sepia Filter",
                        })
                      }
                    >
                      <img
                        src="https://main.mobile.doss.co.id/storage/uploads/2022/08/sepia-03.webp"
                        srcSet="https://main.mobile.doss.co.id/storage/uploads/2022/08/sepia-03.webp"
                        alt="Sepia Filter"
                      />
                      <figcaption>
                        <h4 className="from-top h6 mb-0">Sepia Filter</h4>
                      </figcaption>
                    </figure>
                  </div>
                  <div className="item col-md-6 col-xl-4 gallery-item">
                    <figure
                      className="overlay rounded"
                      onClick={() =>
                        handlePreview({
                          img: "https://main.mobile.doss.co.id/storage/uploads/2022/08/sepia-05.webp",
                          title: "Sepia Filter",
                        })
                      }
                    >
                      <img
                        src="https://main.mobile.doss.co.id/storage/uploads/2022/08/sepia-05.webp"
                        srcSet="https://main.mobile.doss.co.id/storage/uploads/2022/08/sepia-05.webp"
                        alt="Sepia Filter"
                      />
                      <figcaption>
                        <h4 className="from-top h6 mb-0">Sepia Filter</h4>
                      </figcaption>
                    </figure>
                  </div>
                  <div className="item col-md-6 col-xl-4 gallery-item">
                    <figure
                      className="overlay rounded"
                      onClick={() =>
                        handlePreview({
                          img: "https://main.mobile.doss.co.id/storage/uploads/2022/08/sepia-13.webp",
                          title: "Sepia Filter",
                        })
                      }
                    >
                      <img
                        src="https://main.mobile.doss.co.id/storage/uploads/2022/08/sepia-13.webp"
                        srcSet="https://main.mobile.doss.co.id/storage/uploads/2022/08/sepia-13.webp"
                        alt="Sepia Filter"
                      />
                      <figcaption>
                        <h4 className="from-top h6 mb-0">Sepia Filter</h4>
                      </figcaption>
                    </figure>
                  </div>
                  {/* <div className="item col-md-6 col-xl-4 gallery-item">
                    <figure
                      className="overlay rounded"
                      onClick={() =>
                        handlePreview({ img: TwelveImg, title: "Brazil" })
                      }
                    >
                      <img src={TwelveImg} srcSet={TwelveImg} alt="" />
                      <figcaption>
                        <h4 className="from-top h6 mb-0">Brazil</h4>
                      </figcaption>
                    </figure>
                  </div> */}
                  <div className="item col-md-6 col-xl-4 gallery-item">
                    <figure
                      className="overlay rounded"
                      onClick={() =>
                        handlePreview({
                          img: "https://main.mobile.doss.co.id/storage/uploads/2022/08/sepia-23.webp",
                          title: "Sepia Filter",
                        })
                      }
                    >
                      <img
                        src="https://main.mobile.doss.co.id/storage/uploads/2022/08/sepia-23.webp"
                        srcSet="https://main.mobile.doss.co.id/storage/uploads/2022/08/sepia-23.webp"
                        alt="Sepia Filter"
                      />
                      <figcaption>
                        <h4 className="from-top h6 mb-0">Sepia Filter</h4>
                      </figcaption>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MyGallery;
